import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
    Box,
    Grid,
    Stack,
    Button,
    TextField,
    Paper,
    TextareaAutosize,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    styled,
    useTheme,
    Tooltip,
    Tab,
    OutlinedInput,
    MenuItem,
    FormControl,
    Select,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Autocomplete,
    createFilterOptions
} from "@mui/material";

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import CheckIcon from '@mui/icons-material/Check';
import { EvaluationService } from "src/services";
import HorizontalSplitOutlinedIcon from '@mui/icons-material/HorizontalSplitOutlined';
import AddIcon from '@mui/icons-material/Add';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import AlertService from "src/services/AlertService";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertFromHTML, convertToRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { PageLoading } from "src/components";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useHistory } from 'react-router';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTranslation } from "react-i18next";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

const useStyles = makeStyles((theme) => ({

    main: {
        backgroundColor: "#f5f6f7",
        height: "100%"
    },
    root: {
        marginLeft: '24px',
        marginRight: '24px'
    },
    head: {
        color: '#0009b7',
        fontWeight: 'regular',
        padding: '6px 0'
    },
    formLabel: {
        textAlign: 'right',
        fontWeight: 'bold',
        paddingTop: '24.5px !important'
    },
    tableHeader: {
        fontWeight: 'bold !important',
        color: '#ffffff !important',
        backgroundColor: '#00ace2'
    },
    formControl: {
        margin: theme.spacing(1),
        width: 300
    }
}));

const wrapperStyle = {
    border: '1px solid #969696',
    height: '250px'
}
const editorStyle = {
    height: '190px',
    padding: '0 10px'
}

const ColorIconButton = styled(IconButton)(({ theme }) => ({
    backgroundColor: '#0fbef5',
    '&:hover': {
        backgroundColor: '#0fbef5',
    },
}));

function EvaForm(props) {
    const theme = useTheme();
    const history = useHistory();
    const classes = useStyles();
    const [pageNo, setPageNo] = useState(1);
    const [fullEdit, setFullEdit] = useState(true);
    const { t, i18n } = useTranslation();
    /*---------------------------------------------------begin form state---------------------------------------------------*/
    const [onLoading, setOnLoading] = useState(false);

    const prefixVersionName = new Date().getFullYear() + ' - ';
    const [versionName, setVersionName] = useState(prefixVersionName);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date("3000/01/01"));
    const [minScore, setMinScore] = useState(2.50);
    const [totalScoreWeight, setTotalScoreWeight] = useState('');
    const [esgFormNameTH, setEsgFormNameTH] = useState('');
    const [esgFormNameEN, setEsgFormNameEN] = useState('');
    const [editStateDetailTH, setEditorStateDetailTH] = useState(EditorState.createEmpty());
    const [editStateDetailEN, setEditorStateDetailEN] = useState(EditorState.createEmpty());
    const [esgFormDetailTH, setEsgFormDetailTH] = useState('');
    const [esgFormDetailEN, setEsgFormDetailEN] = useState('');

    const [fullForm, setFullForm] = useState([]);
    /*---------------------------------------------------end form state---------------------------------------------------*/


    /*---------------------------------------------------begin section state---------------------------------------------------*/
    const [sectionList, setSectionList] = useState([]);
    const [mainVersionID, setMainVersionID] = useState('');
    const [subVersionID, setSubVersionID] = useState('');
    const [oldSubVersionID, setOldSubVersionID] = useState('');
    const [sectionId, setSectionId] = useState('');
    const [sectionCode, setSectionCode] = useState('');
    const [esgSectionNameTH, setEsgSectionNameTH] = useState('');
    const [esgSectionNameEN, setEsgSectionNameEN] = useState('');
    const [scoreWeight, setScoreWeight] = useState('');

    const [addSection, setAddSection] = useState(false);
    const [editSectionRow, setEditSectionRow] = useState(0);
    /*---------------------------------------------------end section state---------------------------------------------------*/

    /*---------------------------------------------------begin subSection state---------------------------------------------------*/
    const [subSectionList, setSubSectionList] = useState([]);
    const [subSectionId, setSubSectionId] = useState();
    const [esgSubSectionNameTH, setEsgSubSectionNameTH] = useState('');
    const [esgSubSectionNameEN, setEsgSubSectionNameEN] = useState('');

    const [addSubSection, setAddSubSection] = useState(false);
    const [editSubSectionRow, setEditSubSectionRow] = useState(0);

    const [showSubSectionTab, setShowSubSectionTab] = useState(false);
    const [isDeleteSubSection, setIsDeleteSubSection] = useState(false);
    /*---------------------------------------------------end subSection state---------------------------------------------------*/


    /*---------------------------------------------------begin question state---------------------------------------------------*/
    const [questionList, setQuestionList] = useState([]);
    const [masterAnswer, setMasterAnswer] = useState([]);
    const [showQuestionTab, setShowQuestionTab] = useState(false);
    const [tabValue, setTabValue] = useState('');
    const [fileList, setFileList] = useState([]);
    const [fileTest, setFileTest] = useState();
    /*---------------------------------------------------end question state---------------------------------------------------*/

    /*---------------------------------------------------begin questionChoice state---------------------------------------------------*/
    const [questionChoiceScore, setQuestionChoiceScore] = useState('');
    const [questionChoiceNameTH, setQuestionChoiceNameTH] = useState('');
    const [questionChoiceNameEN, setQuestionChoiceNameEN] = useState('');
    const [questionChoiceAnswer, setQuestionChoiceAnswer] = useState([]);

    const [addQuestionChoice, setAddQuestionChoice] = useState(false);
    const [editQuestionChoice, setEditQuestionChoice] = useState(0);
    const [questionRunningNo, setQuestionRunningNo] = useState(-1);
    /*---------------------------------------------------end questionChoice state-----------------------------------------------------*/



    /*-------------------------------------begin header button bar handle & function-------------------------------------*/
    const handleSaveData = (formStatus) => {
        if (formStatus === '2' && new Date(startDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
            AlertService.question({ html: 'วันที่เริ่มใช้งานน้อยกว่าวันที่ปัจจุบัน <br/> กด "Confirm" เพื่อเปลี่ยนวันที่เริ่มใช้งานเป็นวันที่ปัจจุบัน <br/> หรือกด "Cancel" เพื่อเลือกวันที่เริ่มใช้งานเอง' })
                .then((res) => {
                    if (res.isConfirmed) {
                        setStartDate(new Date());

                        if (isDeleteSubSection) {
                            EvaluationService.DeleteSubSectionBySectionId(mainVersionID, subVersionID, sectionId).then(
                                (resp) => {
                                    setIsDeleteSubSection(false);
                                    saveDate(formStatus);
                                }
                            );
                        }

                        saveDate(formStatus);
                    }
                });
        }
        else {
            if (isDeleteSubSection) {
                EvaluationService.DeleteSubSectionBySectionId(mainVersionID, subVersionID, sectionId).then(
                    (resp) => {
                        setIsDeleteSubSection(false);
                        saveDate(formStatus);
                    }
                );
            }
            else {
                saveDate(formStatus);
            }

        }
    }

    function saveDate(formStatus) {
        if (pageNo === 1) {
            if (validatePage1()) {
                var data = getDataPage1(formStatus);
                setOnLoading(true);
                EvaluationService.SaveEvaForm1(data).then(
                    (resp) => {
                        setOnLoading(false);
                        if (resp.message === "success_draft") {
                            AlertService.success({ html: 'บันทึกข้อมูลสำเร็จ' }).then(() => {
                                if (mode === 1)
                                    window.location.href = '/Evaluation/Edit/'.concat(resp.data)
                            });
                        }
                        else if (resp.message === "success_publish") {
                            AlertService.success({ html: 'ยืนยันใช้แบบประเมินสำเร็จ' }).then(() => {
                                window.location.href = '/Evaluation'
                            });
                        }
                        else if (resp.message === "fail_validate_question") {
                            AlertService.warning({ html: 'ไม่สามารถยืนยืนใช้แบบประเมินได้ กรุณาเพิ่มคำถามให้ครบทุกหมวดคำถามก่อนยืนยืนใช้แบบประเมิน' });
                        }
                        else if (resp.message === "fail_duplicate_publish") {
                            var sDate1 = startDate.split("T")[0];
                            var sDate2 = sDate1.split("-")[2] + "/" + sDate1.split("-")[1] + "/" + sDate1.split("-")[0];
                            var eDate1 = endDate.split("T")[0];
                            var eDate2 = eDate1.split("-")[2] + "/" + eDate1.split("-")[1] + "/" + eDate1.split("-")[0];

                            AlertService.confirm({ html: 'ยืนยันการแก้ไขแบบประเมิน' + " (" + sDate2 + " - " + eDate2 + ")" })
                                .then((res) => {
                                    if (res.isConfirmed) {
                                        setOnLoading(true);
                                        EvaluationService.ConfirmPublishForm(resp.data, startDate).then(
                                            (resp) => {
                                                setOnLoading(false);
                                                AlertService.success({ html: 'ยืนยันใช้แบบประเมินสำเร็จ' }).then(() => {
                                                    window.location.href = '/Evaluation'
                                                });
                                            }
                                        );
                                    }
                                });
                        }
                    }
                );
            }
        }
        else if (pageNo === 2) {
            if (showSubSectionTab) {
                if (subSectionList.length === 0) {
                    AlertService.error({ html: 'กรุณาเพิ่มหมวดคำถามย่อย' });
                    return;
                }

                var data = {
                    MainVersionId: mainVersionID,
                    SubVersionId: subVersionID,
                    statusForm: formStatus,
                    startDate: startDate,
                    endDate: endDate,
                    SectionId: sectionId,
                    EsgSectionNameTh: esgSectionNameTH,
                    EsgSectionNameEn: esgSectionNameEN,
                    subSectionList: subSectionList
                }

                setOnLoading(true);
                EvaluationService.SaveEvaForm2SubSection(data).then(
                    (resp1) => {
                        if (resp1.message === "success_draft") {
                            updateFormDataState();

                            var getSectionData = {
                                MainVersionId: mainVersionID,
                                SubVersionId: subVersionID,
                                SectionId: sectionId
                            }

                            EvaluationService.GetSectionData(getSectionData).then(
                                (resp2) => {
                                    setSubSectionList(resp2.subSectionList);
                                }
                            );

                            setOnLoading(false);
                            AlertService.success({ html: 'บันทึกข้อมูลสำเร็จ' });
                        }
                        else if (resp1.message === "success_publish") {
                            setOnLoading(false);
                            AlertService.success({ html: 'ยืนยันใช้แบบประเมินสำเร็จ' }).then(() => {
                                window.location.href = '/Evaluation'
                            });
                        }
                        else if (resp1.message === "fail_validate_question") {
                            setOnLoading(false);
                            AlertService.warning({ html: 'ไม่สามารถยืนยืนใช้แบบประเมินได้ กรุณาเพิ่มคำถามให้ครบทุกหมวดคำถามก่อนยืนยืนใช้แบบประเมิน' });
                        }
                        else if (resp1.message === "fail_duplicate_publish") {
                            var sDate1 = startDate.split("T")[0];
                            var sDate2 = sDate1.split("-")[2] + "/" + sDate1.split("-")[1] + "/" + sDate1.split("-")[0];
                            var eDate1 = endDate.split("T")[0];
                            var eDate2 = eDate1.split("-")[2] + "/" + eDate1.split("-")[1] + "/" + eDate1.split("-")[0];

                            setOnLoading(false);
                            AlertService.confirm({ html: 'ยืนยันการแก้ไขแบบประเมิน' + " (" + sDate2 + " - " + eDate2 + ")" })
                                .then((res) => {
                                    if (res.isConfirmed) {
                                        setOnLoading(true);
                                        EvaluationService.ConfirmPublishForm(resp1.data, startDate).then(
                                            (resp) => {
                                                setOnLoading(false);
                                                AlertService.success({ html: 'ยืนยันใช้แบบประเมินสำเร็จ' }).then(() => {
                                                    window.location.href = '/Evaluation'
                                                });
                                            }
                                        );
                                    }
                                });
                        }
                    }
                );
            }
            else if (showQuestionTab) {
                if (validateQuestionList()) {
                    var data = {
                        MainVersionId: mainVersionID,
                        SubVersionId: subVersionID,
                        statusForm: formStatus,
                        startDate: startDate,
                        endDate: endDate,
                        SectionId: sectionId,
                        EsgSectionNameTh: esgSectionNameTH,
                        EsgSectionNameEn: esgSectionNameEN,
                        QuestionList: questionList,
                        fileList: fileList
                    }
                    setOnLoading(true);
                    EvaluationService.SaveEvaForm2Question(data).then(
                        (resp1) => {
                            setOnLoading(false);
                            if (resp1.message === "success_draft") {
                                updateFormDataState();
                                setOnLoading(false);
                                AlertService.success({ html: 'บันทึกข้อมูลสำเร็จ' });
                            }
                            else if (resp1.message === "success_publish") {
                                AlertService.success({ html: 'ยืนยันใช้แบบประเมินสำเร็จ' }).then(() => {
                                    window.location.href = '/Evaluation'
                                });
                            }
                            else if (resp1.message === "fail_validate_question") {
                                AlertService.warning({ html: 'ไม่สามารถยืนยืนใช้แบบประเมินได้ กรุณาเพิ่มคำถามให้ครบทุกหมวดคำถามก่อนยืนยืนใช้แบบประเมิน' });
                            }
                            else if (resp1.message === "fail_duplicate_publish") {
                                var sDate1 = startDate.split("T")[0];
                                var sDate2 = sDate1.split("-")[2] + "/" + sDate1.split("-")[1] + "/" + sDate1.split("-")[0];
                                var eDate1 = endDate.split("T")[0];
                                var eDate2 = eDate1.split("-")[2] + "/" + eDate1.split("-")[1] + "/" + eDate1.split("-")[0];

                                AlertService.confirm({ html: 'ยืนยันการแก้ไขแบบประเมิน' + " (" + sDate2 + " - " + eDate2 + ")" })
                                    .then((res) => {
                                        if (res.isConfirmed) {
                                            setOnLoading(true);
                                            EvaluationService.ConfirmPublishForm(resp1.data, startDate).then(
                                                (resp) => {
                                                    setOnLoading(false);
                                                    AlertService.success({ html: 'ยืนยันใช้แบบประเมินสำเร็จ' }).then(() => {
                                                        window.location.href = '/Evaluation'
                                                    });
                                                }
                                            );
                                        }
                                    });
                            }
                        }
                    );
                }
            }
            else {
                AlertService.error({ html: 'กรุณาเพิ่มหมวดคำถามย่อยหรือคำถาม' });
            }
        }
        else if (pageNo === 3) {
            if (questionList.length === 0) {
                AlertService.error({ html: 'กรุณาเพิ่มคำถาม' });
                return;
            }

            if (validateQuestionList()) {
                var data = {
                    MainVersionId: mainVersionID,
                    SubVersionId: subVersionID,
                    statusForm: formStatus,
                    startDate: startDate,
                    endDate: endDate,
                    SectionId: sectionId,
                    SubSectionId: subSectionId,
                    EsgSectionNameTh: esgSectionNameTH,
                    EsgSectionNameEn: esgSectionNameEN,
                    esgSubSectionNameTh: esgSubSectionNameTH,
                    esgSubSectionNameEn: esgSubSectionNameEN,
                    QuestionList: questionList,
                    fileList: fileList
                }
                setOnLoading(true);
                EvaluationService.SaveEvaForm3(data).then(
                    (resp1) => {
                        setOnLoading(false);
                        if (resp1.message === "success_draft") {
                            updateFormDataState();
                            setOnLoading(false);
                            AlertService.success({ html: 'บันทึกข้อมูลสำเร็จ' });
                        }
                        else if (resp1.message === "success_publish") {
                            AlertService.success({ html: 'ยืนยันใช้แบบประเมินสำเร็จ' }).then(() => {
                                window.location.href = '/Evaluation'
                            });
                        }
                        else if (resp1.message === "fail_validate_question") {
                            AlertService.warning({ html: 'ไม่สามารถยืนยืนใช้แบบประเมินได้ กรุณาเพิ่มคำถามให้ครบทุกหมวดคำถามก่อนยืนยืนใช้แบบประเมิน' });
                        }
                        else if (resp1.message === "fail_duplicate_publish") {
                            var sDate1 = startDate.split("T")[0];
                            var sDate2 = sDate1.split("-")[2] + "/" + sDate1.split("-")[1] + "/" + sDate1.split("-")[0];
                            var eDate1 = endDate.split("T")[0];
                            var eDate2 = eDate1.split("-")[2] + "/" + eDate1.split("-")[1] + "/" + eDate1.split("-")[0];

                            AlertService.confirm({ html: 'ยืนยันการแก้ไขแบบประเมิน' + " (" + sDate2 + " - " + eDate2 + ")" })
                                .then((res) => {
                                    if (res.isConfirmed) {
                                        setOnLoading(true);
                                        EvaluationService.ConfirmPublishForm(resp1.data, startDate).then(
                                            (resp) => {
                                                setOnLoading(false);
                                                AlertService.success({ html: 'ยืนยันใช้แบบประเมินสำเร็จ' }).then(() => {
                                                    window.location.href = '/Evaluation'
                                                });
                                            }
                                        );
                                    }
                                });
                        }
                    }
                );
            }
        }
    }

    const validateQuestionList = () => {
        var result = questionList.every(obj => {
            if (obj.esgQuestionNameTh === '') {
                AlertService.error({ html: 'กรุณาระบุคำถาม (ภาษาไทย) (Tab ' + obj.questionCode + '.)' });
                setTabValue(obj.questionCode);
                return false;
            }
            else if (obj.questionChoice.length === 0) {
                AlertService.error({ html: 'กรุณาเพิ่มคำตอบ (Tab ' + obj.questionCode + '.)' });
                setTabValue(obj.questionCode);
                return false;
            }

            return true;
        });

        return result;
    }

    const updateFormDataState = () => {
        EvaluationService.GetEvaFormData1(props.id).then(
            (resp) => {
                setFullForm(resp);
            }
        );
    }

    const handleBack = () => {
        if (pageNo === 1)
            window.location.href = '/Evaluation'
        else if (pageNo === 2) {
            setIsDeleteSubSection(false);
            setShowSubSectionTab(false);
            setShowQuestionTab(false);
            clearSectionValue();
            setQuestionRunningNo(-1);
            setPageNo(1);
        }
        else if (pageNo === 3) {
            setShowQuestionTab(false);
            setSubSectionId();
            setQuestionRunningNo(-1);
            setPageNo(2);
        }
    };

    const validatePage1 = () => {
        let sumScoreWeight = sectionList.reduce(function (prev, current) {
            return prev + +current.scoreWeight
        }, 0);

        if (versionName === prefixVersionName) {
            AlertService.error({ html: 'กรุณาระบุ Version' });
        }
        else if (startDate === null) {
            AlertService.error({ html: 'กรุณาระบุวันที่เริ่มใช้งาน' });
        }
        else if (endDate === null) {
            AlertService.error({ html: 'กรุณาระบุวันที่สิ้นสุดใช้งาน' });
        }
        else if (minScore === '') {
            AlertService.error({ html: 'กรุณาระบุคะแนนขั้นต่ำที่ผ่านเกณฑ์' });
        }
        else if (esgFormNameTH === '') {
            AlertService.error({ html: 'กรุณาระบุชื่อแบบประเมิน (ภาษาไทย)' });
        }
        else if (esgFormDetailTH === '') {
            AlertService.error({ html: 'กรุณาระบุคำอธิบายแบบประเมิน (ภาษาไทย)' });
        }
        else if (sectionList.length === 0) {
            AlertService.error({ html: 'กรุณาเพิ่มหมวดคำถาม' });
        }
        else if (sumScoreWeight !== Number(totalScoreWeight)) {
            AlertService.error({ html: 'น้ำหนัก Weight % ของแต่ละหมวดคำถามรวมกันแล้วต้องเท่ากับน้ำหนัก Weight % รวม' });
        }
        else {
            return true;
        }
        return false;
    }

    function getDataPage1(formStatus) {
        return {
            mainVersionID: mainVersionID,
            versionName: versionName,
            subVersionID: subVersionID,
            oldSubVersionID: oldSubVersionID,
            startDate: formStatus === '2' && new Date(startDate) < new Date() ? toISOStringWithTimezone(new Date()) : toISOStringWithTimezone(startDate),
            endDate: toISOStringWithTimezone(endDate),
            minScore: minScore,
            totalScoreWeight: totalScoreWeight,
            esgFormNameTH: esgFormNameTH,
            esgFormNameEN: esgFormNameEN,
            esgFormDetailTH: esgFormDetailTH,
            esgFormDetailEN: esgFormDetailEN,
            statusForm: formStatus,
            actionBy: 'admin',
            sectionList: sectionList
        }
    }
    /*-------------------------------------end header button bar handle & function-------------------------------------*/


    /*-------------------------------------begin FORM handle & function-------------------------------------*/
    const handleVersionNameChange = (event) => {
        var value = event.target.value;
        if (value.length < prefixVersionName.length)
            setVersionName(prefixVersionName);
        else
            setVersionName(value.startsWith(prefixVersionName) ? value : prefixVersionName + value);
    };

    const handleEditorDetailTHChange = (event) => {
        var htmlvalue = draftToHtml(convertToRaw(event.getCurrentContent()))
        setEsgFormDetailTH(htmlvalue);
        setEditorStateDetailTH(event);
    }

    const handleEditorDetailENChange = (event) => {
        var htmlvalue = draftToHtml(convertToRaw(event.getCurrentContent()))
        setEsgFormDetailEN(htmlvalue);
        setEditorStateDetailEN(event);
    }

    const toISOStringWithTimezone = date => {
        if (typeof (date) === 'string') {
            return date.length == 19 ? date + "+07:00" : date;
        }
        else {
            const tzOffset = -date.getTimezoneOffset();
            const diff = tzOffset >= 0 ? '+' : '-';
            const pad = n => `${Math.floor(Math.abs(n))}`.padStart(2, '0');
            return date.getFullYear() +
                '-' + pad(date.getMonth() + 1) +
                '-' + pad(date.getDate()) +
                'T' + pad(date.getHours()) +
                ':' + pad(date.getMinutes()) +
                ':' + pad(date.getSeconds()) +
                diff + pad(tzOffset / 60) +
                ':' + pad(tzOffset % 60);
        }
    };
    /*-------------------------------------end form handle & function-------------------------------------*/


    /*-------------------------------------begin SECTION handle & function-------------------------------------*/
    const openAddSection = () => {
        setEditSectionRow(-1);
        setAddSection(true)
    }

    const confirmAddSection = () => {
        if (!validateSection()) {
            return;
        }
        var seqNo = 1;
        if (sectionList.length > 0) {
            var maxSeq = Math.max(...sectionList.map(o => o.seqNo));
            seqNo = maxSeq + 1;
        }

        setSectionList([...sectionList, {
            mainVersionID: mainVersionID, subVersionID: subVersionID, sectionId: null, seqNo: seqNo,
            sectionCode: sectionCode, esgSectionNameTh: esgSectionNameTH, esgSectionNameEn: esgSectionNameEN, scoreWeight: scoreWeight, fullScore: null
        }])
        clearSectionValue();
        setAddSection(false);
        setEditSectionRow(0);
    }

    const cancelAddSection = () => {
        clearSectionValue();
        setAddSection(false);
        setEditSectionRow(0);
    }

    const manageSectionIconTab = (row) => (
        <Grid container direction="row" justifyContent="center">
            <IconButton disabled={editSectionRow < 0} onClick={() => EditSection(row)}>
                <EditIcon fontSize="small" />
            </IconButton>
            {fullEdit ? <IconButton disabled={editSectionRow < 0} onClick={() => deleteSection(row)}>
                <DeleteIcon fontSize="small" />
            </IconButton> : null}
            {fullEdit ? <IconButton disabled={editSectionRow < 0} onClick={() => reSeqSection(row)}>
                <SwapVertIcon fontSize="small" />
            </IconButton> : null}
        </Grid>
    );

    const EditSection = (row) => {
        setSectionCode(row.sectionCode);
        setEsgSectionNameTH(row.esgSectionNameTh);
        setEsgSectionNameEN(row.esgSectionNameEn);
        setScoreWeight(row.scoreWeight);
        setEditSectionRow(row.seqNo);
    }

    const deleteSection = (row) => {
        const newSectionList = sectionList.filter(item => item.seqNo !== row.seqNo);
        setSectionList(newSectionList);
    }

    const reSeqSection = (row) => {
        let currSeq = row.seqNo;

        const newSectionList = sectionList.map(obj => {
            if (currSeq === sectionList.length) {
                if (obj.seqNo === currSeq) {
                    return { ...obj, seqNo: 1 };
                }
                else if (obj.seqNo === 1) {
                    return { ...obj, seqNo: sectionList.length };
                }
            }
            else {
                if (obj.seqNo === currSeq) {
                    return { ...obj, seqNo: currSeq + 1 };
                }
                else if (obj.seqNo === currSeq + 1) {
                    return { ...obj, seqNo: currSeq };
                }
            }

            return obj;
        });

        newSectionList.sort((a, b) => (a.seqNo > b.seqNo) ? 1 : -1)
        setSectionList(newSectionList);
    }

    const editSectionIconTab = (row) => (
        <Grid container columns={16} direction="row" justifyContent="left">
            <IconButton onClick={() => confirmEditSection(row)}>
                <CheckIcon fontSize="small" />
            </IconButton>
            <IconButton onClick={() => cancelEditSection()}>
                <DeleteIcon fontSize="small" />
            </IconButton>
        </Grid>
    );

    const confirmEditSection = (row) => {
        if (!validateSection(row)) {
            return;
        }

        const newSectionList = sectionList.map(obj => {
            if (obj.seqNo === row.seqNo) {
                return { ...obj, sectionCode: sectionCode, esgSectionNameEn: esgSectionNameEN, esgSectionNameTh: esgSectionNameTH, scoreWeight: scoreWeight };
            }

            return obj;
        });

        setSectionList(newSectionList);
        clearSectionValue();
        setEditSectionRow(0);
    }

    const cancelEditSection = () => {
        clearSectionValue();
        setEditSectionRow(0);
    }

    const handleRowSectionClick = (row) => {
        if (mode === 1) {
            AlertService.error({ html: 'กรุณาบันทึกร่างก่อน' });
        }
        if (mode === 2) {
            setSectionId(row.sectionId);
            if (validatePage1()) {
                var data = getDataPage1();
                var getSectionData = {
                    MainVersionId: row.mainVersionId,
                    SubVersionId: row.subVersionId,
                    SectionId: row.sectionId
                }
                setOnLoading(true);
                EvaluationService.SaveEvaForm1(data).then(
                    (resp1) => {
                        EvaluationService.GetSectionData(getSectionData).then(
                            (resp2) => {
                                setSectionCode(row.sectionCode);
                                setEsgSectionNameTH(row.esgSectionNameTh);
                                setEsgSectionNameEN(row.esgSectionNameEn);
                                setSubSectionList(resp2.subSectionList);
                                setQuestionList(resp2.questionList);
                                if (resp2.subSectionList.length > 0)
                                    setShowSubSectionTab(true);
                                else if (resp2.questionList.length > 0) {
                                    setTabValue(resp2.questionList[0].questionCode);
                                    setShowQuestionTab(true);
                                }
                                setOnLoading(false);
                                setPageNo(2);
                            }
                        );

                        setSectionCode(row.sectionCode);
                        setEsgSectionNameTH(row.esgSectionNameTh);
                        setEsgSectionNameEN(row.esgSectionNameEn || '');
                        setPageNo(2);
                    }
                );
            }
        }
        else if (mode === 3) {
            var getSectionData = {
                MainVersionId: row.mainVersionId,
                SubVersionId: row.subVersionId,
                SectionId: row.sectionId
            }
            setOnLoading(true);
            EvaluationService.GetSectionData(getSectionData).then(
                (resp2) => {
                    setSectionCode(row.sectionCode);
                    setEsgSectionNameTH(row.esgSectionNameTh);
                    setEsgSectionNameEN(row.esgSectionNameEn);
                    setSubSectionList(resp2.subSectionList);
                    setQuestionList(resp2.questionList);
                    if (resp2.subSectionList.length > 0)
                        setShowSubSectionTab(true);
                    else if (resp2.questionList.length > 0) {
                        setTabValue(resp2.questionList[0].questionCode);
                        setShowQuestionTab(true);
                    }
                    setOnLoading(false);
                    setPageNo(2);
                }
            );

        }
    };

    const clearSectionValue = () => {
        setSectionCode('');
        setEsgSectionNameTH('');
        setEsgSectionNameEN('');
        setScoreWeight('');
    }

    const validateSection = (row) => {
        var duplicate = [];
        if (row !== undefined) {
            duplicate = sectionList.filter(item => item.sectionCode.toLowerCase() === sectionCode.toLowerCase() && item.sectionCode.toLowerCase() !== row.sectionCode.toLowerCase());
        } else if (sectionCode.trim().length > 0) {
            duplicate = sectionList.filter(item => item.sectionCode.toLowerCase() === sectionCode.toLowerCase());
        }
        if (sectionCode.trim().length === 0) {
            AlertService.error({ html: 'กรุณากรอกหัวข้อหมวดคำถาม' });
            return false;
        }
        else if (duplicate.length > 0) {
            AlertService.error({ html: 'หัวข้อหมวดคำถามซ้ำ กรุณากรอกหัวข้อหมวดคำถามใหม่' });
            return false;
        }
        else if (esgSectionNameTH.trim().length === 0) {
            AlertService.error({ html: 'กรุณาหมวดคำถาม (ภาษาไทย)' });
            return false;
        }
        return true;
    }
    /*-------------------------------------end section handle & function-------------------------------------*/


    /*-------------------------------------begin subSection handle & function-------------------------------------*/
    const handleAddSubSection = () => {
        setShowSubSectionTab(true);
    }

    const handleCancelAddSubSection = () => {
        setSubSectionList([]);
        setQuestionList([]);
        setIsDeleteSubSection(true);
        setShowSubSectionTab(false);
    }

    const openAddSubSection = () => {
        setEsgSubSectionNameTH('');
        setEsgSubSectionNameEN('');
        setEditSubSectionRow(-1);
        setAddSubSection(true)
    }

    const addSubSectionIconTab = () => (
        <Grid container columns={16} direction="row" justifyContent="left">
            <IconButton onClick={() => confirmAddSubSection()}>
                <CheckIcon fontSize="small" />
            </IconButton>
            <IconButton onClick={() => cancelAddSubSection()}>
                <DeleteIcon fontSize="small" />
            </IconButton>
        </Grid>
    );

    const confirmAddSubSection = () => {
        var seqNo = 1;
        if (subSectionList.length > 0) {
            var maxSeq = Math.max(...subSectionList.map(o => o.seqNo));
            seqNo = maxSeq + 1;
        }

        setSubSectionList([...subSectionList, {
            mainVersionID: mainVersionID, subVersionID: subVersionID, sectionId: sectionId, SubSectionId: null,
            esgsubSectionNameTh: esgSubSectionNameTH, esgsubSectionNameEn: esgSubSectionNameEN, seqNo: seqNo
        }])

        clearSubSectionValue();
        setAddSubSection(false);
    }

    const cancelAddSubSection = () => {
        clearSubSectionValue();
        setAddSubSection(false);
    }

    const manageSubSectionIconTab = (row) => (
        <Grid container direction="row" justifyContent="center">
            <IconButton disabled={editSectionRow < 0} onClick={() => EditSubSection(row)}>
                <EditIcon fontSize="small" />
            </IconButton>
            <IconButton disabled={editSectionRow < 0} onClick={() => deleteSubSection(row)}>
                <DeleteIcon fontSize="small" />
            </IconButton>
            <IconButton disabled={editSectionRow < 0} onClick={() => reSeqSubSection(row)}>
                <SwapVertIcon fontSize="small" />
            </IconButton>
        </Grid>
    );

    const EditSubSection = (row) => {
        setEsgSubSectionNameTH(row.esgsubSectionNameTh);
        setEsgSubSectionNameEN(row.esgsubSectionNameEn);
        setEditSubSectionRow(row.seqNo);
    }

    const deleteSubSection = (row) => {
        const newSubSectionList = subSectionList.filter(item => item.seqNo !== row.seqNo);
        setSubSectionList(newSubSectionList);
    }

    const reSeqSubSection = (row) => {
        let currSeq = row.seqNo;

        const newSubSectionList = subSectionList.map(obj => {
            if (currSeq === subSectionList.length) {
                if (obj.seqNo === currSeq) {
                    return { ...obj, seqNo: 1 };
                }
                else if (obj.seqNo === 1) {
                    return { ...obj, seqNo: subSectionList.length };
                }
            } else {
                if (obj.seqNo === currSeq) {
                    return { ...obj, seqNo: currSeq + 1 };
                }
                else if (obj.seqNo === currSeq + 1) {
                    return { ...obj, seqNo: currSeq };
                }
            }
            return obj;
        });

        newSubSectionList.sort((a, b) => (a.seqNo > b.seqNo) ? 1 : -1)
        setSubSectionList(newSubSectionList);
    }

    const editSubSectionIconTab = (row) => (
        <Grid container columns={16} direction="row" justifyContent="left">
            <IconButton onClick={() => confirmEditSubSection(row)}>
                <CheckIcon fontSize="small" />
            </IconButton>
            <IconButton onClick={() => cancelEditSubSection()}>
                <DeleteIcon fontSize="small" />
            </IconButton>
        </Grid>
    );

    const confirmEditSubSection = (row) => {
        if (esgSubSectionNameTH.trim().length === 0) {
            AlertService.error({ html: 'กรุณาหมวดคำถาม (ภาษาไทย)' });
            return;
        }

        const newSubSectionList = subSectionList.map(obj => {
            if (obj.seqNo === row.seqNo) {
                return { ...obj, esgsubSectionNameTh: esgSubSectionNameTH, esgsubSectionNameEn: esgSubSectionNameEN };
            }

            return obj;
        });

        setSubSectionList(newSubSectionList);
        clearSubSectionValue();
        setEditSubSectionRow(0);
    }

    const cancelEditSubSection = () => {
        clearSubSectionValue();
        setEditSubSectionRow(0);
    }

    const clearSubSectionValue = () => {
        setEsgSubSectionNameTH('');
        setEsgSubSectionNameEN('');
    }

    const handleRowSubSectionClick = (row) => {
        if (row.mainVersionId === undefined) {
            AlertService.error({ html: 'กรุณากดบันทึกร่าง ก่อนดูรายละเอียดหมวดคำถามย่อย' });
        } else {
            var getQuestionData = {
                MainVersionId: row.mainVersionId,
                SubVersionId: row.subVersionId,
                SectionId: row.sectionId,
                SubSectionId: row.subSectionId
            }
            setOnLoading(true);
            EvaluationService.GetQuestionData(getQuestionData).then((resp) => {
                setSubSectionId(row.subSectionId);
                setEsgSubSectionNameTH(row.esgsubSectionNameTh);
                setEsgSubSectionNameEN(row.esgsubSectionNameEn);
                setQuestionList(resp.questionList);
                if (resp.questionList.length > 0) {
                    setTabValue(resp.questionList[0].questionCode);
                    setShowQuestionTab(true);
                }
                setOnLoading(false);
                setPageNo(3);
            });
        }
    };


    /*-------------------------------------end subSection handle & function-------------------------------------*/


    /*-------------------------------------begin question handle & function-------------------------------------*/

    const handleAddQuestion = () => {
        if (pageNo === 2 && subSectionList.length > 0) {
            var newSubSectionList = subSectionList.length = 0;
            setSubSectionList(newSubSectionList);
        }

        var seq = 0;
        if (isDeleteSubSection && questionList.length === 0) {
            seq = 1
        }
        else if (questionRunningNo === -1) {
            seq = fullForm.questionList.filter(x => x.sectionId === sectionId).length + 1;
        }
        else {
            seq = questionRunningNo + 1;
        }
        if (questionList.length > 0) {
            var tempSeq = Number(questionList[questionList.length - 1].questionCode.replace(sectionCode, '')) + 1;
            seq = tempSeq < seq ? tempSeq : seq;
        }

        setQuestionRunningNo(seq);
        var _questionCode = sectionCode + seq;
        setQuestionList([...questionList, {
            mainVersionId: mainVersionID, subVersionId: subVersionID, sectionId: sectionId, subSectionId: subSectionId, questionId: null,
            questionCode: _questionCode, esgQuestionNameTh: '', esgQuestionNameEn: '', flagNotPtt: false, flagPtt: false,
            flagNotScore: false, flagRemark: false, flagExamRelDoc: false, remarkTh: '', remarkEn: '', examRelDocTh: '', examRelDocEn: '',
            questionAnswer: [], questionChoice: [], file: null, files: []
        }])
        setShowQuestionTab(true);
        setTabValue(_questionCode);
    }

    const handleCopyQuestion = () => {
        var seq = 0;
        if (questionRunningNo === -1) {
            seq = fullForm.questionList.filter(x => x.sectionId === sectionId).length + 1;
        } else {
            seq = questionRunningNo + 1;
        }
        if (questionList.length > 0) {
            var tempSeq = Number(questionList[questionList.length - 1].questionCode.replace(sectionCode, '')) + 1;
            seq = tempSeq < seq ? tempSeq : seq;
        }

        setQuestionRunningNo(seq);
        var _questionCode = sectionCode + seq;

        var copyData = questionList.filter(x => x.sectionId === sectionId && x.questionCode === tabValue);

        const copyChoice = copyData[0].questionChoice.map(object => {
            return { ...object, questionChoiceId: null };
        });

        const copyFile = copyData[0].files.map(object => {
            return { ...object, questionCode: _questionCode };
        });

        setQuestionList([...questionList, {
            mainVersionId: mainVersionID, subVersionId: subVersionID, sectionId: sectionId, subSectionId: subSectionId, questionId: null,
            questionCode: _questionCode, esgQuestionNameTh: copyData[0].esgQuestionNameTh, esgQuestionNameEn: copyData[0].esgQuestionNameEn, flagNotPtt: copyData[0].flagNotPtt, flagPtt: copyData[0].flagPtt,
            flagNotScore: copyData[0].flagNotScore, flagRemark: copyData[0].flagRemark, flagExamRelDoc: copyData[0].flagExamRelDoc, remarkTh: copyData[0].remarkTh, remarkEn: copyData[0].remarkEn, examRelDocTh: copyData[0].examRelDocTh, examRelDocEn: copyData[0].examRelDocEn,
            questionAnswer: copyData[0].questionAnswer, questionChoice: copyChoice, file: copyData[0].file, files: copyFile
        }])
        // setShowQuestionTab(true);
        setTabValue(_questionCode);
    }

    const handleDeleteQuestion = () => {
        var deleteData = questionList.filter(x => x.sectionId === sectionId && x.questionCode !== tabValue);

        setQuestionList(deleteData);
        if (deleteData.length > 0)
            setTabValue(deleteData[0].questionCode);
        else {
            setShowQuestionTab(false);
            setQuestionRunningNo(0);
        }
    }

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleQustionChange = (event, fieldName) => {
        var value = event.target.value;
        var value2 = event.target.checked;

        const newQuestionList = questionList.map(obj => {
            if (obj.questionCode === tabValue) {
                if (fieldName === 'nameTH')
                    return { ...obj, esgQuestionNameTh: value };
                else if (fieldName === 'nameEN')
                    return { ...obj, esgQuestionNameEn: value };
                else if (fieldName === 'FlagNotPtt')
                    return { ...obj, flagNotPtt: value2 };
                else if (fieldName === 'FlagPtt')
                    return { ...obj, flagPtt: value2 };
                else if (fieldName === 'FlagNotScore')
                    return { ...obj, flagNotScore: value2 };
                else if (fieldName === 'FlagRemark')
                    return { ...obj, flagRemark: value2 };
                else if (fieldName === 'FlagExamRelDoc')
                    return { ...obj, flagExamRelDoc: value2 };
                else if (fieldName === 'Remark')
                    return { ...obj, remarkTh: value, remarkEn: value };
                else if (fieldName === 'ExamRelDoc')
                    return { ...obj, examRelDocTh: value, examRelDocEn: value };
                else if (fieldName === 'questionAnswer')
                    return { ...obj, questionAnswer: value.length > 0 ? value.sort() : value };
                else if (fieldName === 'file') {
                    var seqNo = 1;
                    if (obj.files.length > 0) {
                        var maxSeq = Math.max(...obj.files.map(o => o.seqNo));
                        seqNo = maxSeq + 1;
                    }

                    var tempFile = fileList;
                    var tempFileName = new Array();
                    var tempFileList = obj.files;

                    for (let i = 0; i < event.target.files.length; i++) {
                        // setFileList([...fileList, event.target.files[i]]);
                        if (event.target.files[i].size > 10485760) {
                            AlertService.error({ html: 'ไม่สามารถอัพโหลดไฟล์ที่มีขนาดไม่เกิน 10 MB ได้' });
                        }
                        else {
                            tempFile.push(event.target.files[i]);
                            tempFileName.push(event.target.files[i].name);
                            setFileTest(URL.createObjectURL(event.target.files[0]));
                            tempFileList.push({ questionCode: tabValue, fileName: event.target.files[i].name, srcFile: URL.createObjectURL(event.target.files[i]), fileSize: event.target.files[i].size, seqNo: seqNo })
                            seqNo += 1;
                        }
                    }
                    setFileList(tempFile);
                    return { ...obj, fileName: tempFileName };
                }
            }
            return obj;
        });
        setQuestionList(newQuestionList);

    }

    const handleQuestionAnswer = (event, value) => {
        const newQuestionList = questionList.map(obj => {
            if (obj.questionCode === tabValue) {
                return { ...obj, questionAnswer: value.length > 0 ? value.sort() : value };
            }
            return obj;
        });
        setQuestionList(newQuestionList);
    };

    const handleQuestionChoiceAnswer = (event, value) => {
        setQuestionChoiceAnswer(value);
    };

    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
    /*---------------------------------------end question handle & function-------------------------------------*/


    /*-------------------------------------begin questionChoice handle & function-------------------------------------*/
    const openAddQuestionChoice = () => {
        setAddQuestionChoice(true);
    }

    const confirmAddQuestionChoice = () => {
        if (!validateQuestionChoice()) {
            return;
        }

        const newQuestionList = questionList.map(obj => {
            if (obj.questionCode === tabValue) {
                var seqNo = obj.questionChoice.length + 1;
                obj.questionChoice.push({ questionChoiceScore: questionChoiceScore, questionChoiceNameTh: questionChoiceNameTH, questionChoiceNameEn: questionChoiceNameEN, seqNo: seqNo, questionChoiceAnswer: questionChoiceAnswer });
                return obj;
            }

            return obj;
        });

        setQuestionList(newQuestionList);
        clearQuestionChoiceValue();
        setAddQuestionChoice(false);
    }

    const cancelAddQuestionChoice = () => {
        clearQuestionChoiceValue();
        setAddQuestionChoice(false);
    }

    const manageQuestionChoiceIconTab = (row) => (
        <Grid container columns={16} direction="row" justifyContent="left">
            <IconButton disabled={editSectionRow < 0} onClick={() => EditQuestionChoice(row)}>
                <EditIcon fontSize="small" />
            </IconButton>
            <IconButton disabled={editSectionRow < 0} onClick={() => deleteQuestionChoice(row)}>
                <DeleteIcon fontSize="small" />
            </IconButton>
            <IconButton disabled={editSectionRow < 0} onClick={() => reSeqQuestionChoice(row)}>
                <SwapVertIcon fontSize="small" />
            </IconButton>
        </Grid>
    );

    const EditQuestionChoice = (row) => {
        setQuestionChoiceScore(row.questionChoiceScore);
        setQuestionChoiceNameTH(row.questionChoiceNameTh);
        setQuestionChoiceNameEN(row.questionChoiceNameEn);
        setQuestionChoiceAnswer(row.questionChoiceAnswer);
        setEditQuestionChoice(row.seqNo);
    }

    const deleteQuestionChoice = (row) => {
        const newQuestionList = questionList.map(obj => {
            if (obj.questionCode === tabValue) {
                obj.questionChoice = obj.questionChoice.filter(item => item.seqNo !== row.seqNo);
                return obj;
            }

            return obj;
        });

        setQuestionList(newQuestionList);
    }

    const reSeqQuestionChoice = (row) => {
        let currSeq = row.seqNo;

        const newQuestionList = questionList.map(obj => {
            if (obj.questionCode === tabValue) {
                obj.questionChoice.map(obj2 => {
                    if (currSeq === obj.questionChoice.length) {
                        if (obj2.seqNo === currSeq) {
                            obj2.seqNo = 1;
                        }
                        else if (obj2.seqNo === 1) {
                            obj2.seqNo = obj.questionChoice.length;
                        }
                    }
                    else {
                        if (obj2.seqNo === currSeq) {
                            obj2.seqNo = currSeq + 1;
                        }
                        else if (obj2.seqNo === currSeq + 1) {
                            obj2.seqNo = currSeq;
                        }
                    }
                });
                return obj;
            }
            return obj;
        });
        questionList.find(x => x.questionCode === tabValue).questionChoice.sort((a, b) => (a.seqNo > b.seqNo) ? 1 : -1);
        setQuestionList(newQuestionList);
    }

    const editQuestionChoiceIconTab = (row) => (
        <Grid container columns={16} direction="row" justifyContent="left">
            <IconButton onClick={() => confirmEditQuestionChoice(row)}>
                <CheckIcon fontSize="small" />
            </IconButton>
            <IconButton onClick={() => cancelEditQuestionChoice()}>
                <DeleteIcon fontSize="small" />
            </IconButton>
        </Grid>
    );

    const confirmEditQuestionChoice = (row) => {
        if (!validateQuestionChoice()) {
            return;
        }

        const newQuestionList = questionList.map(obj => {
            if (obj.questionCode === tabValue) {
                obj.questionChoice.map(obj2 => {
                    if (obj2.seqNo === row.seqNo) {
                        obj2.questionChoiceNameTh = questionChoiceNameTH;
                        obj2.questionChoiceNameEn = questionChoiceNameEN;
                        obj2.questionChoiceAnswer = questionChoiceAnswer;
                    }
                });

                return obj;
            }

            return obj;
        });

        setQuestionList(newQuestionList);
        clearQuestionChoiceValue();
        setEditQuestionChoice(0);
    }

    const cancelEditQuestionChoice = () => {
        clearSubSectionValue();
        setEditSubSectionRow(0);
    }

    const clearQuestionChoiceValue = () => {
        setQuestionChoiceScore('');
        setQuestionChoiceNameTH('');
        setQuestionChoiceNameEN('');
        setQuestionChoiceAnswer([]);
    }

    const validateQuestionChoice = () => {
        if (questionChoiceScore.toString().trim().length === 0) {
            AlertService.error({ html: 'กรุณาระบุคะแนน' });
            return false;
        }
        else if (questionChoiceNameTH.trim().length === 0) {
            AlertService.error({ html: 'กรุณาระบุหลักเกณฑ์การให้คะแนน (ภาษาไทย)' });
            return false;
        }
        else if (questionChoiceAnswer.length === 0) {
            AlertService.error({ html: 'กรุณาระบุคำตอบ' });
            return false;
        }
        return true;
    }

    const deleteQuestionFile = (row) => {
        const newQuestionList = questionList.map(obj => {
            if (obj.questionCode === tabValue) {
                obj.files = obj.files.filter(item => item.seqNo !== row.seqNo);
                return obj;
            }

            return obj;
        });

        setQuestionList(newQuestionList);
    }
    /*---------------------------------------end questionChoice handle & function-------------------------------------*/


    /*--------------------------------------mode : 1 = Create, 2 = Edit, 3 = View--------------------------------------*/
    var mode = 0;
    if (props.mode.toLowerCase() === 'create')
        mode = 1;
    else if (props.mode.toLowerCase() === 'edit')
        mode = 2;
    else if (props.mode.toLowerCase() === 'view')
        mode = 3;
    /*-----------------------------------------------------------------------------------------------------------------*/

    useEffect(() => {
        if (props.id !== undefined) {
            setOnLoading(true);
            EvaluationService.GetEvaFormData1(props.id).then(
                (resp) => {

                    setFullForm(resp);
                    if (mode === 1)
                        setOldSubVersionID(resp.form.subVersionID);
                    if (mode === 2 || mode === 3)
                        setSubVersionID(resp.form.subVersionID);
                    setMainVersionID(resp.form.mainVersionID);
                    setVersionName(resp.form.versionName);
                    setStartDate(resp.form.startDate);
                    setEndDate(resp.form.endDate);
                    setMinScore(resp.form.minScore);
                    setTotalScoreWeight(resp.form.totalScoreWeight || '');
                    setEsgFormNameTH(resp.form.esgFormNameTH);
                    setEsgFormNameEN(resp.form.esgFormNameEN || '');
                    setSectionList(resp.sectionList);

                    if (resp.form.esgFormDetailTH !== null) {
                        const blocksFromHTML = convertFromHTML(resp.form.esgFormDetailTH);
                        const state = ContentState.createFromBlockArray(
                            blocksFromHTML.contentBlocks,
                            blocksFromHTML.entityMap,
                        );
                        setEsgFormDetailTH(resp.form.esgFormDetailTH);
                        setEditorStateDetailTH(EditorState.createWithContent(state));
                    }
                    if (resp.form.esgFormDetailEN !== null) {
                        const blocksFromHTML = convertFromHTML(resp.form.esgFormDetailEN);
                        const state = ContentState.createFromBlockArray(
                            blocksFromHTML.contentBlocks,
                            blocksFromHTML.entityMap,
                        );
                        setEsgFormDetailEN(resp.form.esgFormDetailEN);
                        setEditorStateDetailEN(EditorState.createWithContent(state));
                    }

                    if ((mode === 2 && resp.form.subVersionID > 0) || (mode === 3))
                        setFullEdit(false);

                    setOnLoading(false);
                }
            );


        }

        EvaluationService.GetMasterAnswer().then((resp) => {
            setMasterAnswer(resp);
        });

    }, [])

    return (
        <div className={classes.main}>
            <PageLoading open={onLoading} />
            <div className={classes.root}>
                {/* button bar */}
                <Grid container spacing={2} columns={16} style={{ margin: "0", width: "100%", paddingBottom: "15px" }}>
                    <Grid item xs={8}>
                        <div className={classes.head}>
                            <h1>{t("EvaForm.headerLabel")}</h1>
                        </div>
                    </Grid>
                    <Grid item xs={8}>
                        <Stack spacing={1} direction="row" justifyContent="flex-end" alignItems="center">
                            {mode === 2 || mode === 3 ? <Button style={{ backgroundColor: "#37cfd0", fontWeight: "bold" }} variant="contained"
                                onClick={() => history.push({ pathname: '/VendorSelfAssessment', state: { vendor: 0, main: mainVersionID, sub: subVersionID, type: "SelfAssessment_V", isViewMode: true } })}>{t("EvaForm.btnPreview")}</Button> : null}
                            {mode === 1 || mode === 2 ? <Button onClick={() => { handleSaveData('1') }} style={{ backgroundColor: "#ff8c06", fontWeight: "bold" }} variant="contained">{t("EvaForm.btnSaveDraft")}</Button> : null}
                            {mode === 2 ?
                                <Button onClick={() => {
                                    var sDate1 = startDate.split("T")[0];
                                    var sDate2 = sDate1.split("-")[2] + "/" + sDate1.split("-")[1] + "/" + sDate1.split("-")[0];
                                    var eDate1 = endDate.split("T")[0];
                                    var eDate2 = eDate1.split("-")[2] + "/" + eDate1.split("-")[1] + "/" + eDate1.split("-")[0];
                                    AlertService.confirm({
                                        html: t("EvaForm.messageConfirmPublish") + sDate2 + " - " + eDate2,
                                    }).then((value) => value.isConfirmed && handleSaveData('2'));
                                }} style={{ backgroundColor: "#04b22b", fontWeight: "bold" }} variant="contained">{t("EvaForm.btnConfirmPublish")}</Button>
                                : null}
                            <Button onClick={handleBack} style={{ backgroundColor: "#a7a5a5", fontWeight: "bold" }} variant="contained">{t("EvaForm.btnBack")}</Button>
                        </Stack>
                    </Grid>
                </Grid>

                {/* Eva Form */}
                {pageNo === 1 ? <div><Box sx={{ bgcolor: '#ffffff', borderRadius: '10px', padding: '20px' }}>
                    <Grid container spacing={2}>
                        {/* 1st row */}
                        <Grid item xs={2} className={classes.formLabel}>
                            <label>Version</label><span style={{ color: 'red' }}>*</span>
                        </Grid>
                        <Grid item xs={3}>
                            <TextField disabled={mode === 3} required size="small" style={{ width: '350px' }} value={versionName} onChange={handleVersionNameChange} />
                        </Grid>
                        <Grid item xs={1} className={classes.formLabel}>
                            <label>{t("EvaForm.startDate")}</label><span style={{ color: 'red' }}>*</span>
                        </Grid>
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    disabled={mode === 3}
                                    minDate={new Date()}
                                    inputFormat="dd/MM/yyyy"
                                    mask="__/__/____"
                                    value={startDate}
                                    onChange={(event) => setStartDate(toISOStringWithTimezone(event))}
                                    renderInput={(params) => <TextField size="small" style={{ backgroundColor: 'white' }} fullWidth  {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={1} className={classes.formLabel}>
                            <label>{t("EvaForm.endDate")}</label><span style={{ color: 'red' }}>*</span>
                        </Grid>
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    minDate={new Date()}
                                    maxDate={new Date("3000/01/01")}
                                    disabled={mode === 3}
                                    inputFormat="dd/MM/yyyy"
                                    mask="__/__/____"
                                    value={endDate}
                                    onChange={(event) => setEndDate(toISOStringWithTimezone(event))}
                                    renderInput={(params) => <TextField size="small" style={{ backgroundColor: 'white' }} fullWidth  {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>

                        {/* 2nd row */}
                        <Grid item xs={2} className={classes.formLabel}>
                            <label>{t("EvaForm.minScore")}</label><span style={{ color: 'red' }}>*</span>
                        </Grid>
                        <Grid item xs={1}>
                            <TextField disabled={mode === 3} type="number" value={minScore} onChange={(event) => setMinScore(event.target.value)} size="small" style={{ width: '80px' }} />
                        </Grid>
                        <Grid item xs={1.5} className={classes.formLabel}>
                            <label>{t("EvaForm.totalScoreWeight")}</label>
                        </Grid>
                        <Grid item xs={7}>
                            <TextField disabled={mode === 3} type="number" value={totalScoreWeight} onChange={(event) => setTotalScoreWeight(event.target.value)} size="small" style={{ width: '80px' }} />
                        </Grid>

                        {/* 3rd row */}
                        <Grid item xs={2} className={classes.formLabel}>
                            <label>{t("EvaForm.formNameTH")}</label><span style={{ color: 'red' }}>*</span>
                        </Grid>
                        <Grid item xs={10}>
                            <TextField
                                required disabled={mode === 3} value={esgFormNameTH} onChange={(event) => setEsgFormNameTH(event.target.value)} size="small" sx={{ width: '95%' }} />
                        </Grid>

                        {/* 4th row */}
                        <Grid item xs={2} className={classes.formLabel}>
                            <label>{t("EvaForm.formNameEN")}</label>
                        </Grid>
                        <Grid item xs={10}>
                            <TextField disabled={mode === 3} size="small" value={esgFormNameEN} onChange={(event) => setEsgFormNameEN(event.target.value)} sx={{ width: '95%' }} />
                        </Grid>

                        {/* 5 row */}
                        <Grid item xs={2} className={classes.formLabel}>
                            <label>{t("EvaForm.detailTH")}</label><span style={{ color: 'red' }}>*</span>
                        </Grid>
                        <Grid item xs={4} className={classes.formLabel}>
                        </Grid>
                        <Grid item xs={6} sx={{ fontWeight: 'bold', paddingTop: '24.5px !important' }}>
                            <label>{t("EvaForm.detailEN")}</label>
                        </Grid>

                        {/* 6 row */}
                        <Grid item xs={6} sx={{ paddingTop: '0 !important' }}>
                            <Editor
                                editorState={editStateDetailTH}
                                wrapperStyle={wrapperStyle}
                                editorStyle={editorStyle}
                                readOnly={mode === 3}
                                toolbar={{
                                    options: ["inline", "list"],
                                    inline: {
                                        options: ["bold", "italic", "underline"]
                                    },
                                    list: {
                                        options: ['unordered', 'ordered']
                                    }
                                }}
                                onEditorStateChange={handleEditorDetailTHChange}
                            />
                        </Grid>
                        <Grid item xs={6} sx={{ paddingTop: '0 !important' }}>
                            <Editor
                                editorState={editStateDetailEN}
                                wrapperStyle={wrapperStyle}
                                editorStyle={editorStyle}
                                readOnly={mode === 3}
                                toolbar={{
                                    options: ["inline", "list"],
                                    inline: {
                                        options: ["bold", "italic", "underline"]
                                    },
                                    list: {
                                        options: ['unordered', 'ordered']
                                    }
                                }}
                                onEditorStateChange={handleEditorDetailENChange}
                            />
                        </Grid>

                    </Grid>
                </Box>
                    <br />
                    {/* Eva Question */}
                    <Box sx={{ bgcolor: '#ffffff', borderRadius: '10px', padding: '20px' }}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        {mode === 3 ? null : <TableCell sx={{ width: '160px' }} align="center" className={classes.tableHeader}></TableCell>}
                                        <TableCell sx={{ width: '160px' }} align="center" className={classes.tableHeader}>{t("EvaForm.sectionCode")}<span style={{ color: 'red' }}>*</span></TableCell>
                                        <TableCell sx={{ width: '470px' }} align="left" className={classes.tableHeader}>{t("EvaForm.sectionNameTH")}<span style={{ color: 'red' }}>*</span></TableCell>
                                        <TableCell sx={{ width: '470px' }} align="left" className={classes.tableHeader}>{t("EvaForm.sectionNameEN")}</TableCell>
                                        <TableCell align="center" className={classes.tableHeader}>{t("EvaForm.sectionScoreWeight")}</TableCell>
                                        <TableCell sx={{ width: '160px' }} align="center" className={classes.tableHeader}>{t("EvaForm.TotalQuestion")}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {sectionList.map((row) => (
                                        <TableRow key={row.sectionCode} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                            {editSectionRow !== row.seqNo ?
                                                <>
                                                    {mode === 3 ? null : <TableCell align="center">{manageSectionIconTab(row)}</TableCell>}
                                                    <TableCell style={{ cursor: 'pointer' }} align="center" onClick={() => { handleRowSectionClick(row) }} component="th" scope="row">{row.sectionCode}</TableCell>
                                                    <TableCell style={{ cursor: 'pointer' }} align="left" onClick={() => { handleRowSectionClick(row) }}>{row.esgSectionNameTh}</TableCell>
                                                    <TableCell style={{ cursor: 'pointer' }} align="left" onClick={() => { handleRowSectionClick(row) }}>{row.esgSectionNameEn}</TableCell>
                                                    <TableCell style={{ cursor: 'pointer' }} align="center" onClick={() => { handleRowSectionClick(row) }}>{row.scoreWeight}</TableCell>
                                                    <TableCell style={{ cursor: 'pointer' }} align="center" onClick={() => { handleRowSectionClick(row) }}>
                                                        {fullForm.questionList ? fullForm.questionList.filter(x => x.sectionId === row.sectionId).length > 0 ? fullForm.questionList.filter(x => x.sectionId === row.sectionId).length : '-' : '-'}
                                                    </TableCell>
                                                </>
                                                :
                                                <>
                                                    <TableCell align="center">{editSectionIconTab(row)}</TableCell>
                                                    <TableCell component="th" scope="row" align="center">
                                                        <TextField disabled={!fullEdit} inputProps={{ min: 0, style: { textAlign: 'center' } }} variant="standard"
                                                            value={sectionCode} onChange={(event) => setSectionCode(event.target.value)} />
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        <TextField value={esgSectionNameTH} sx={{ width: '100%' }} onChange={(event) => setEsgSectionNameTH(event.target.value)} variant="standard" />
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        <TextField value={esgSectionNameEN} sx={{ width: '100%' }} onChange={(event) => setEsgSectionNameEN(event.target.value)} variant="standard" />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField disabled={!fullEdit} inputProps={{ min: 0, style: { textAlign: 'center' } }} variant="standard" type="number"
                                                            value={scoreWeight} onChange={(event) => setScoreWeight(event.target.value)} />
                                                    </TableCell>
                                                    <TableCell align="center">-</TableCell>
                                                </>
                                            }
                                        </TableRow>
                                    ))}
                                    {addSection ?
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                            <TableCell align="center">
                                                <Grid container columns={16} direction="row" justifyContent="left">
                                                    <IconButton onClick={() => confirmAddSection()}>
                                                        <CheckIcon fontSize="small" />
                                                    </IconButton>
                                                    <IconButton onClick={() => cancelAddSection()}>
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Grid>
                                            </TableCell>
                                            <TableCell component="th" scope="row" align="center">
                                                <TextField inputProps={{ min: 0, style: { textAlign: 'center' } }} variant="standard"
                                                    value={sectionCode} onChange={(event) => setSectionCode(event.target.value)} />
                                            </TableCell>
                                            <TableCell align="left">
                                                <TextField value={esgSectionNameTH} sx={{ width: '100%' }} onChange={(event) => setEsgSectionNameTH(event.target.value)} variant="standard" />
                                            </TableCell>
                                            <TableCell align="left">
                                                <TextField value={esgSectionNameEN} sx={{ width: '100%' }} onChange={(event) => setEsgSectionNameEN(event.target.value)} variant="standard" />
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField inputProps={{ min: 0, style: { textAlign: 'center' } }} variant="standard" type="number"
                                                    value={scoreWeight} onChange={(event) => setScoreWeight(event.target.value)} />
                                            </TableCell>
                                            <TableCell align="center">-</TableCell>
                                        </TableRow>
                                        : null}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <br />
                        {fullEdit ? <Button disabled={editSectionRow !== 0} variant="outlined" onClick={() => { openAddSection() }} style={{ color: '#ffbb6b', borderColor: '#ffbb6b', fontWeight: 'bold' }}>+ {t("EvaForm.addSubject")}</Button> : null}
                    </Box></div> : null}
                {(pageNo === 2 || pageNo === 3) ?
                    <div>
                        <Box sx={{ bgcolor: '#ffffff', borderRadius: '10px', padding: '20px' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={2} className={classes.formLabel}>
                                    <label>{t("EvaForm.sectionNameTH")}</label><span style={{ color: 'red' }}>*</span>
                                </Grid>
                                <Grid item xs={(showSubSectionTab || pageNo === 3) ? 10 : 9} className={classes.formLabel}>
                                    <TextField disabled size="small" value={sectionCode} inputProps={{ min: 0, style: { textAlign: 'center' } }} sx={{ width: '45.75px' }} />
                                    <TextField disabled size="small" value={esgSectionNameTH} onChange={(event) => setEsgSectionNameTH(event.target.value)} sx={{ width: 'calc(100% - 55.75px)', paddingLeft: '10px' }} />
                                </Grid>
                                {(!showSubSectionTab && !showQuestionTab) ? <Grid item xs={1} className={classes.formLabel}>
                                    <Tooltip title={t("EvaForm.addSubSection")}>
                                        <ColorIconButton onClick={handleAddSubSection} aria-label="search" size="small"  >
                                            <HorizontalSplitOutlinedIcon sx={{ color: 'white' }} />
                                        </ColorIconButton>
                                    </Tooltip>
                                </Grid> : null}
                                {(fullEdit && showQuestionTab && pageNo !== 3) ?
                                    <Grid item xs={1} className={classes.formLabel}>
                                        {!showQuestionTab ?
                                            <Tooltip title={t("EvaForm.addQuestion")}>
                                                <ColorIconButton onClick={handleAddQuestion} sx={{ color: '#1dc3a6', backgroundColor: "#1dc3a6" }} aria-label="search" size="small"  >
                                                    <AddIcon sx={{ color: 'white' }} />
                                                </ColorIconButton>
                                            </Tooltip>
                                            : null}
                                    </Grid>
                                    : null
                                }

                                <Grid item xs={2} className={classes.formLabel}>
                                    <label>{t("EvaForm.sectionNameEN")}</label>
                                </Grid>
                                <Grid item xs={showSubSectionTab ? 10 : 9} className={classes.formLabel}>
                                    <TextField disabled size="small" inputProps={{ min: 0, style: { textAlign: 'center' } }} value={sectionCode} sx={{ width: '45.75px' }} />
                                    <TextField disabled size="small" value={esgSectionNameEN || ''} onChange={(event) => setEsgSectionNameEN(event.target.value)} sx={{ width: 'calc(100% - 55.75px)', paddingLeft: '10px' }} />
                                </Grid>
                                {(fullEdit && !showSubSectionTab && !showQuestionTab) ? <Grid item xs={1} className={classes.formLabel}>
                                    <Tooltip title={t("EvaForm.addQuestion")}>
                                        <ColorIconButton onClick={handleAddQuestion} sx={{ color: '#1dc3a6', backgroundColor: "#1dc3a6" }} aria-label="search" size="small"  >
                                            <AddIcon sx={{ color: 'white' }} />
                                        </ColorIconButton>
                                    </Tooltip>
                                </Grid> : null}
                            </Grid>
                        </Box>
                        <br />
                        {pageNo === 3 ?
                            <div>
                                <Box sx={{ bgcolor: '#ffffff', borderRadius: '10px', padding: '20px' }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={2} className={classes.formLabel}>
                                            <label>{t("EvaForm.subSectionNameTH")}</label><span style={{ color: 'red' }}>*</span>
                                        </Grid>
                                        <Grid item xs={9} className={classes.formLabel}>
                                            <TextField disabled size="small" value={esgSubSectionNameTH} onChange={(event) => setEsgSubSectionNameTH(event.target.value)} sx={{ width: '100%', paddingLeft: '10px' }} />
                                        </Grid>
                                        <Grid item xs={1} className={classes.formLabel}>
                                            {fullEdit && !showQuestionTab ? <Tooltip title={t("EvaForm.addQuestion")}>
                                                <ColorIconButton onClick={handleAddQuestion} sx={{ color: '#1dc3a6', backgroundColor: "#1dc3a6" }} aria-label="search" size="small"  >
                                                    <AddIcon sx={{ color: 'white' }} />
                                                </ColorIconButton>
                                            </Tooltip> : null}
                                        </Grid>

                                        <Grid item xs={2} className={classes.formLabel}>
                                            <label>{t("EvaForm.subSectionNameEN")}</label>
                                        </Grid>
                                        <Grid item xs={9} className={classes.formLabel}>
                                            <TextField disabled size="small" value={esgSubSectionNameEN} onChange={(event) => setEsgSubSectionNameEN(event.target.value)} sx={{ width: '100%', paddingLeft: '10px' }} />
                                        </Grid>
                                    </Grid>
                                </Box><br />
                            </div> : null}
                        {(showSubSectionTab && pageNo !== 3) ? <Box sx={{ bgcolor: '#ffffff', borderRadius: '10px', padding: '20px' }}>
                            {mode === 3 ? null : <Button variant="outlined" onClick={() => { handleCancelAddSubSection() }} style={{ color: 'red', borderColor: 'red', fontWeight: 'bold', float: 'right', marginBottom: '10px' }}>{t("EvaForm.removeSubSection")}</Button>}
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            {mode === 3 ? null : <TableCell sx={{ width: '160px' }} className={classes.tableHeader}></TableCell>}
                                            <TableCell align="left" className={classes.tableHeader}>{t("EvaForm.subSectionNameTH")}</TableCell>
                                            <TableCell align="left" className={classes.tableHeader}>{t("EvaForm.subSectionNameEN")}</TableCell>
                                            <TableCell sx={{ width: '160px' }} align="center" className={classes.tableHeader}>{t("EvaForm.TotalQuestion")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {subSectionList.map((row) => (
                                            <TableRow key={row.seqNo} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                {editSubSectionRow !== row.seqNo ?
                                                    <>
                                                        {mode === 3 ? null : <TableCell align="center">{manageSubSectionIconTab(row)}</TableCell>}
                                                        <TableCell style={{ cursor: 'pointer' }} align="left" onClick={() => { handleRowSubSectionClick(row) }}>{row.esgsubSectionNameTh}</TableCell>
                                                        <TableCell style={{ cursor: 'pointer' }} align="left" onClick={() => { handleRowSubSectionClick(row) }}>{row.esgsubSectionNameEn}</TableCell>
                                                        <TableCell style={{ cursor: 'pointer' }} align="center" onClick={() => { handleRowSubSectionClick(row) }}>
                                                            {fullForm.questionList.filter(x => x.sectionId === sectionId && x.subSectionId === row.subSectionId).length > 0 ?
                                                                fullForm.questionList.filter(x => x.sectionId === sectionId && x.subSectionId === row.subSectionId).length :
                                                                '-'}
                                                        </TableCell>
                                                    </>
                                                    :
                                                    <>
                                                        <TableCell align="center">{editSubSectionIconTab(row)}</TableCell>
                                                        <TableCell align="left">
                                                            <TextField sx={{ width: '100%' }} value={esgSubSectionNameTH} onChange={(event) => setEsgSubSectionNameTH(event.target.value)} variant="standard" />
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            <TextField sx={{ width: '100%' }} value={esgSubSectionNameEN} onChange={(event) => setEsgSubSectionNameEN(event.target.value)} variant="standard" />
                                                        </TableCell>
                                                        <TableCell align="center">-</TableCell>
                                                    </>
                                                }
                                            </TableRow>
                                        ))}
                                        {addSubSection ? <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                            <TableCell align="center">{addSubSectionIconTab()}</TableCell>
                                            <TableCell align="left">
                                                <TextField sx={{ width: '100%' }} value={esgSubSectionNameTH} onChange={(event) => setEsgSubSectionNameTH(event.target.value)} variant="standard" />
                                            </TableCell>
                                            <TableCell align="left">
                                                <TextField sx={{ width: '100%' }} value={esgSubSectionNameEN} onChange={(event) => setEsgSubSectionNameEN(event.target.value)} variant="standard" />
                                            </TableCell>
                                            <TableCell align="center">-</TableCell>
                                        </TableRow> : null}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <br />
                            {mode !== 3 ? <Button variant="outlined" onClick={() => { openAddSubSection() }} style={{ color: '#ffbb6b', borderColor: '#ffbb6b', fontWeight: 'bold' }}>+ {t("EvaForm.addSubSection")}</Button> : null}
                        </Box> : null}

                        {showQuestionTab ? <Box sx={{ bgcolor: '#ffffff', borderRadius: '10px', padding: '20px', height: '80px', marginBottom: '25px', width: '180px', float: 'right' }}>
                            <Tooltip style={{ float: 'right', marginLeft: '5px' }} title={t("EvaForm.deleteQuestion")}>
                                <ColorIconButton onClick={handleDeleteQuestion} sx={{ color: '#1dc3a6', backgroundColor: "#ff5204" }} aria-label="search" size="small"  >
                                    <DeleteOutlineIcon sx={{ color: 'white' }} />
                                </ColorIconButton>
                            </Tooltip>
                            <Tooltip style={{ float: 'right', marginLeft: '5px' }} title={t("EvaForm.copyQuestion")}>
                                <ColorIconButton onClick={handleCopyQuestion} sx={{ color: '#1dc3a6', backgroundColor: "#3d4db8" }} aria-label="search" size="small"  >
                                    <ContentCopyIcon sx={{ color: 'white' }} />
                                </ColorIconButton>
                            </Tooltip>
                            <Tooltip style={{ float: 'right', marginLeft: '5px' }} title={t("EvaForm.addQuestion")}>
                                <ColorIconButton onClick={handleAddQuestion} sx={{ color: '#1dc3a6', backgroundColor: "#1dc3a6" }} aria-label="search" size="small"  >
                                    <AddIcon sx={{ color: 'white' }} text={t("EvaForm.addQuestion")} />
                                </ColorIconButton>
                            </Tooltip>
                        </Box> : null}

                        {(showQuestionTab) ?
                            <Box sx={{ bgcolor: '#ffffff', borderRadius: '10px', padding: '20px' }}>
                                <TabContext value={tabValue}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <TabList variant='scrollable' onChange={handleTabChange} >
                                            {questionList.map((tab) => (
                                                <Tab key={tab.questionCode} label={tab.questionCode + '.'} value={tab.questionCode} />
                                            ))}
                                        </TabList>
                                    </Box>
                                    {questionList.map((tab) => (
                                        <TabPanel value={tab.questionCode}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={1.5} className={classes.formLabel}>
                                                    <label>{t("EvaForm.qeustionNameTH")}</label><span style={{ color: 'red' }}>*</span>
                                                </Grid>
                                                <Grid item xs={10.5} className={classes.formLabel}>
                                                    <TextField disabled size="small" value={tab.questionCode} inputProps={{ min: 0, style: { textAlign: 'center' } }} sx={{ width: '60px' }} />
                                                    <TextField disabled={mode === 3} size="small" value={tab.esgQuestionNameTh} onChange={(event) => handleQustionChange(event, 'nameTH')} sx={{ width: 'calc(100% - 70px)', paddingLeft: '10px' }} />
                                                </Grid>

                                                <Grid item xs={1.5} className={classes.formLabel}>
                                                    <label>{t("EvaForm.questionNameEN")}</label>
                                                </Grid>
                                                <Grid item xs={10.5} className={classes.formLabel}>
                                                    <TextField disabled size="small" inputProps={{ min: 0, style: { textAlign: 'center' } }} value={tab.questionCode} sx={{ width: '60px' }} />
                                                    <TextField disabled={mode === 3} size="small" value={tab.esgQuestionNameEn} onChange={(event) => handleQustionChange(event, 'nameEN')} sx={{ width: 'calc(100% - 70px)', paddingLeft: '10px' }} />
                                                </Grid>

                                                <Grid item xs={1.5} className={classes.formLabel}>
                                                    <label>{t("EvaForm.answer")}</label>
                                                </Grid>
                                                <Grid item xs={3.5}>
                                                    <Stack spacing={3} sx={{ width: "100%" }}>
                                                        <Autocomplete
                                                            disabled={mode === 3}
                                                            multiple
                                                            options={masterAnswer}
                                                            getOptionLabel={(option) => i18n.language === "th" ? option.answerNameTh || "" : option.answerNameEn || "" }
                                                            isOptionEqualToValue={(option, value) =>
                                                                option.answerId === value.answerId
                                                            }
                                                            filterOptions={createFilterOptions({
                                                                limit: 20,
                                                            })}
                                                            value={tab.questionAnswer}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            onChange={handleQuestionAnswer}
                                                        />
                                                    </Stack>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <label style={{ color: 'gray' }}>*{t("EvaForm.answerRemark")}</label>
                                                </Grid>

                                                <Grid item xs={1.5} className={classes.formLabel}>
                                                    <label>{t("EvaForm.score")}</label>
                                                </Grid>
                                                <Grid item xs={4.5}>
                                                    <FormGroup>
                                                        <FormControlLabel disabled={mode === 3} onChange={(event) => handleQustionChange(event, 'FlagNotPtt')} control={<Checkbox checked={tab.flagNotPtt} />} label={t("EvaForm.flagNotPtt")} />
                                                        <FormControlLabel disabled={mode === 3} onChange={(event) => handleQustionChange(event, 'FlagPtt')} control={<Checkbox checked={tab.flagPtt} />} label={t("EvaForm.flagPtt")} />
                                                        <FormControlLabel disabled={mode === 3} onChange={(event) => handleQustionChange(event, 'FlagNotScore')} control={<Checkbox checked={tab.flagNotScore} />} label={t("EvaForm.flagNotScore")} />
                                                    </FormGroup>
                                                </Grid>
                                                <Grid item xs={6}>
                                                </Grid>

                                                <Grid item xs={1.5} className={classes.formLabel}>
                                                    <label>{t("EvaForm.other")}</label>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <FormGroup>
                                                        <FormControlLabel disabled={mode === 3} onChange={(event) => handleQustionChange(event, 'FlagRemark')} control={<Checkbox checked={tab.flagRemark} />} label={t("EvaForm.flagRemark")} />
                                                        {tab.flagRemark ? <TextareaAutosize minRows={3} disabled={mode === 3} style={{ width: '100%', resize: 'none' }} value={tab.remarkTh} onChange={(event) => handleQustionChange(event, 'Remark')} /> : null}
                                                        <FormControlLabel disabled={mode === 3} onChange={(event) => handleQustionChange(event, 'FlagExamRelDoc')} control={<Checkbox checked={tab.flagExamRelDoc} />} label={t("EvaForm.flagExamRelDoc")} />
                                                        {tab.flagExamRelDoc ? <TextareaAutosize minRows={3} disabled={mode === 3} style={{ width: '100%', resize: 'none' }} value={tab.examRelDocTh} onChange={(event) => handleQustionChange(event, 'ExamRelDoc')} /> : null}
                                                    </FormGroup>
                                                    <p style={{ color: 'gray' }}>*{t("EvaForm.otherRemark")}</p>
                                                </Grid>
                                                <Grid item xs={5.5}>
                                                    <div style={{ float: 'right', width: '100px', textAlign: 'center', fontWeight: 'bold', color: '#00ace2', paddingTop: '60px' }}>
                                                        <p>{t("EvaForm.fullScore")}</p>
                                                        {tab.fullScore}
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <TableContainer component={Paper}>
                                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            {mode === 3 ? null : <TableCell sx={{ width: '160px' }} className={classes.tableHeader}></TableCell>}
                                                            <TableCell sx={{ width: '160px' }} align="center" className={classes.tableHeader}>{t("EvaForm.score")}<span style={{ color: 'red' }}>*</span></TableCell>
                                                            <TableCell sx={{ width: '500px' }} align="left" className={classes.tableHeader}>{t("EvaForm.questionChoiceNameTH")}<span style={{ color: 'red' }}>*</span></TableCell>
                                                            <TableCell sx={{ width: '500px' }} align="left" className={classes.tableHeader}>{t("EvaForm.questionChoiceNameEN")}</TableCell>
                                                            <TableCell align="center" className={classes.tableHeader}>{t("EvaForm.answer")}<span style={{ color: 'red' }}>*</span></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {tab.questionChoice.map((row) => (
                                                            <TableRow key={row.seq} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                                {editQuestionChoice !== row.seqNo ?
                                                                    <>
                                                                        {mode === 3 ? null : <TableCell align="center">{manageQuestionChoiceIconTab(row)}</TableCell>}
                                                                        <TableCell align="center" >{row.questionChoiceScore}</TableCell>
                                                                        <TableCell align="left" >{row.questionChoiceNameTh}</TableCell>
                                                                        <TableCell align="left" >{row.questionChoiceNameEn}</TableCell>
                                                                        <TableCell align="left" >
                                                                            <Stack spacing={3} sx={{ width: "100%" }}>
                                                                                <Autocomplete
                                                                                    disabled={true}
                                                                                    multiple
                                                                                    options={tab.questionAnswer}
                                                                                    getOptionLabel={(option) => i18n.language === "th" ? option.answerNameTh || "" : option.answerNameEn || ""}
                                                                                    isOptionEqualToValue={(option, value) =>
                                                                                        option.answerId === value.answerId
                                                                                    }
                                                                                    filterOptions={createFilterOptions({
                                                                                        limit: 20,
                                                                                    })}
                                                                                    value={row.questionChoiceAnswer}
                                                                                    renderInput={(params) => <TextField {...params} />}
                                                                                />
                                                                            </Stack>
                                                                        </TableCell>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <TableCell align="center">{editQuestionChoiceIconTab(row)}</TableCell>
                                                                        <TableCell align="left">
                                                                            <TextField sx={{ width: '100%' }} inputProps={{ min: 0, style: { textAlign: 'center' } }} variant="standard" type="number"
                                                                                value={questionChoiceScore} onChange={(event) => setQuestionChoiceScore(event.target.value)} />
                                                                        </TableCell>
                                                                        <TableCell align="left">
                                                                            <TextField sx={{ width: '100%' }} value={questionChoiceNameTH} onChange={(event) => setQuestionChoiceNameTH(event.target.value)} variant="standard" />
                                                                        </TableCell>
                                                                        <TableCell align="left">
                                                                            <TextField sx={{ width: '100%' }} value={questionChoiceNameEN} onChange={(event) => setQuestionChoiceNameEN(event.target.value)} variant="standard" />
                                                                        </TableCell>
                                                                        <TableCell align="left">
                                                                            <Stack spacing={3} sx={{ width: "100%" }}>
                                                                                <Autocomplete
                                                                                    disabled={mode === 3}
                                                                                    multiple
                                                                                    options={tab.questionAnswer}
                                                                                    getOptionLabel={(option) => i18n.language === "th" ? option.answerNameTh || "" : option.answerNameEn || ""}
                                                                                    isOptionEqualToValue={(option, value) =>
                                                                                        option.answerId === value.answerId
                                                                                    }
                                                                                    filterOptions={createFilterOptions({
                                                                                        limit: 20,
                                                                                    })}
                                                                                    value={questionChoiceAnswer}
                                                                                    renderInput={(params) => <TextField {...params} />}
                                                                                    onChange={handleQuestionChoiceAnswer}
                                                                                />
                                                                            </Stack>
                                                                        </TableCell>
                                                                    </>
                                                                }
                                                            </TableRow>
                                                        ))}
                                                        {addQuestionChoice ?
                                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                                <TableCell align="center">
                                                                    <Grid container columns={16} direction="row" justifyContent="left">
                                                                        <IconButton onClick={() => confirmAddQuestionChoice()}>
                                                                            <CheckIcon fontSize="small" />
                                                                        </IconButton>
                                                                        <IconButton onClick={() => cancelAddQuestionChoice()}>
                                                                            <DeleteIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Grid>
                                                                </TableCell>
                                                                <TableCell align="left">
                                                                    <TextField sx={{ width: '100%' }} inputProps={{ min: 0, style: { textAlign: 'center' } }} variant="standard" type="number"
                                                                        value={questionChoiceScore} onChange={(event) => setQuestionChoiceScore(event.target.value)} />
                                                                </TableCell>
                                                                <TableCell align="left">
                                                                    <TextField sx={{ width: '100%' }} value={questionChoiceNameTH} onChange={(event) => setQuestionChoiceNameTH(event.target.value)} variant="standard" />
                                                                </TableCell>
                                                                <TableCell align="left">
                                                                    <TextField sx={{ width: '100%' }} value={questionChoiceNameEN} onChange={(event) => setQuestionChoiceNameEN(event.target.value)} variant="standard" />
                                                                </TableCell>
                                                                <TableCell align="left">
                                                                    <Stack spacing={3} sx={{ width: "100%" }}>
                                                                        <Autocomplete
                                                                            disabled={mode === 3}
                                                                            multiple
                                                                            options={tab.questionAnswer}
                                                                            getOptionLabel={(option) => i18n.language === "th" ? option.answerNameTh || "" : option.answerNameEn || ""}
                                                                            isOptionEqualToValue={(option, value) =>
                                                                                option.answerId === value.answerId
                                                                            }
                                                                            filterOptions={createFilterOptions({
                                                                                limit: 20,
                                                                            })}
                                                                            value={questionChoiceAnswer}
                                                                            renderInput={(params) => <TextField {...params} />}
                                                                            onChange={handleQuestionChoiceAnswer}
                                                                        />
                                                                    </Stack>
                                                                </TableCell>
                                                            </TableRow> : null}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            <br />
                                            {mode === 3 ? null :
                                                <>
                                                    <Button disabled={editSectionRow !== 0} variant="outlined" onClick={() => { openAddQuestionChoice() }} style={{ color: '#ffbb6b', borderColor: '#ffbb6b', fontWeight: 'bold' }}>+ {t("EvaForm.addQuestionChoice")}</Button>
                                                </>
                                            }

                                            <hr style={{ marginTop: '15px', marginBottom: '15px' }} />

                                            <Grid container spacing={2} style={{ paddingTop: '15px', paddingLeft: '16px', minHeight: '210px' }}>
                                                {mode === 3 ? null : <Grid style={{ textAlign: 'center', border: '1px solid #8080808f' }} item xs={3}>
                                                    <p style={{ fontWeight: 'bold', paddingBottom: '10px' }}>{t("EvaForm.addFileLabel")}</p>
                                                    <input
                                                        type="file"
                                                        accept="image/jpg, image/jpeg, image/png"
                                                        style={{ display: 'none' }}
                                                        id="contained-button-file"
                                                        onChange={(event) => handleQustionChange(event, 'file')}
                                                        multiple
                                                    />
                                                    <label htmlFor="contained-button-file">
                                                        <Button variant="contained" color="primary" component="span" startIcon={<FileUploadIcon />} style={{ width: '300px' }}>
                                                            Upload Files
                                                        </Button>
                                                    </label>
                                                    <p style={{ color: 'red', paddingTop: '15px' }}>&#8226; {t("EvaForm.addFileDesc1")}</p>
                                                    <p style={{ color: 'red' }}>&#8226; {t("EvaForm.addFileDesc2")}</p>
                                                </Grid>}
                                                <Grid item xs={9}>
                                                    <label style={{ fontWeight: 'bold' }}>Files</label>
                                                    {tab.files.map((row) => (
                                                        <div style={{ display: 'flex', width: '520px', borderBottom: '2px solid #80808085', paddingBottom: '10px', paddingTop: '10px' }}>
                                                            <img style={{ width: '60px', height: '60px' }} src={row.srcFile} />
                                                            <div style={{ width: '400px' }}>
                                                                <p style={{ paddingLeft: '10px', fontSize: '22px', fontWeight: 'bold' }}>{row.fileName}</p>
                                                                <p style={{ paddingLeft: '10px', fontSize: '18px' }}>{formatBytes(row.fileSize)}</p>
                                                            </div>
                                                            {mode === 3 ? null : <div style={{ width: '60px', textAlign: 'center', paddingTop: '7px' }}>
                                                                <IconButton onClick={() => { deleteQuestionFile(row) }}>
                                                                    <DeleteIcon fontSize="medium" />
                                                                </IconButton>
                                                            </div>}
                                                        </div>
                                                    ))}
                                                </Grid>
                                            </Grid>
                                        </TabPanel>
                                    ))}
                                </TabContext>
                            </Box> : null}

                    </div>
                    : null}
            </div>
        </div>
    )
}

export default EvaForm;